<template>
	<div class='description-data'>
		<div class='description-data-content-item'>
			<div class='key'>Current Value:</div>
			<div class='value'>$ {{deal.current_value | formatPrice}}</div>
		</div>
		<div class='description-data-content-item'>
			<div class='key'>Total Revenues:</div>
			<div class='value' >$ {{deal.total_revenues | format2}}</div>
		</div>
		<div class='description-data-content-item'>
			<div class='key'>Current Debt:</div>
			<div class='value'>$ {{deal.current_debt | formatPrice}}</div>
		</div>
		<div class='description-data-content-item'>
			<div class='key'>P.I.T.I:</div>
			<div class='value'>$ {{deal.piti | format2}}</div>
		</div>
		<div class='description-data-content-item'>
			<div class='key'>Interest Rate:</div>
			<div class='value'>{{deal.interest_rate | formatPercentage}}%</div>
		</div>
		<div class='description-data-content-item'>
			<div class='key'>Operating Expenses:</div>
			<div class='value'>$ {{deal.operation_expenses | formatPrice}}</div>
		</div>

		<div class='description-data-content-item'>
			<div class='key'>Equity:</div>
			<div class='value'>$ {{deal.equity | formatPrice}}</div>
		</div>
		<div class='description-data-content-item'>
			<div class='key'>Monthly Cashflow:</div>
			<div class='value'>$ {{deal.cashflow}}</div>
		</div>

		<div class='description-data-content-item'>
			<div class='key'> Cash On Cash Return:</div>
			<div class='value'>{{deal.coc | formatPercentage}}%</div>
		</div>
	</div>
</template>

<script>
import deal from '../../..//mixins/deal';
export default {
	mixins:     [deal],
};
</script>
